import React, { useState, useEffect } from "react";
import { Modal, Input, Table, Button, message, Select, Switch } from "antd";
import { CloseOutlined, EditOutlined, SaveOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { http } from "../../services/http";
import { useSelector } from "react-redux";

const ReturnRequestModal = ({
  visible,
  data,
  onClose,
  onSaved,
  isEditable,
  isShowDrivers = false,
}) => {
  const { t } = useTranslation();
  const { warehouse } = useSelector((state) => state.main);

  const [editing, setEditing] = useState(false);
  const [lines, setLines] = useState([]);
  const [saving, setSaving] = useState(false);
  const [driversData, setDriversData] = useState([]);
  const [loadersData, setLoadersData] = useState([]);
  const [carNumbersData, setCarNumbersData] = useState([]);
  const [carNumber, setCarNumber] = useState("");
  const [loaders, setLoaders] = useState([]);
  const [selectedLoadersData, setSelectedLoadersData] = useState([]);
  const [driver, setDriver] = useState("");
  const [savingLoaders, setSavingLoaders] = useState(false);
  const [savingDriver, setSavingDriver] = useState(false);
  const [savingCarNumber, setSavingCarNumber] = useState(false);
  const [loadingLoaders, setLoadingLoaders] = useState(false);
  const [closeDoc, setCloseDoc] = useState(true);

  // Sync lines from data when modal opens or data changes
  useEffect(() => {
    if (data?.documentLines) {
      setLines(data.documentLines.map((l) => ({ ...l, _editQty: l.quantity })));
      setDriver(data.driver);
      // setLoaders(data.loaders || []);
      getLoadersShipping(data?.deliveryId);
      setCarNumber(data.carNumber || "");
    } else {
      setLines([]);
    }

    setEditing(false);
  }, [data, visible]);

  const fetchDrivers = async () => {
    try {
      const { data } = await http.get(
        `api/sales/driver-business-partners?skip=0`,
      );

      setDriversData(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCarNumbers = async () => {
    try {
      const { data } = await http.get(
        `api/inventorytransferrequest/car-numbers`,
      );
      setCarNumbersData(data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchLoaders = async () => {
    try {
      const { data } = await http.get(
        `api/warehouseassistant/employee-business-partners?skip=0`,
      );

      setLoadersData(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDrivers();
    fetchLoaders();
    fetchCarNumbers();
  }, []);

  if (!data) return null;

  const fmt = (n) => new Intl.NumberFormat("fr-FR").format(n ?? 0);

  const handleQtyChange = (lineNum, value) => {
    setLines((prev) =>
      prev.map((l) => (l.lineNum === lineNum ? { ...l, _editQty: value } : l)),
    );
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const body = {
        return: {
          cardCode: data.cardCode,
          docDate: data.docDate,
          docDueDate: data.docDueDate,
          salesPersonCode: data.salesPersonCode,
          returnReason: data.returnReason ?? "",
          driver: driver,
          carNumber: carNumber,
          documentLines: lines.map((l) => ({
            itemCode: l.itemCode,
            quantity: Number(l._editQty),
            warehouseCode: warehouse || "",
            baseType: null,
            baseEntry: data?.docEntry,
            baseLine: l.lineNum,
          })),
        },
        closeBaseDocument: closeDoc,
        delivery: {
          createDate: moment().format("YYYY-MM-DD"),
          orderDeliveryCollection: selectedLoadersData.map((item, index) => ({
            lineId: index + 1,
            employeeId: item.cardCode,
            employeeName: item.cardName,
          })),
        },
      };
      await http.post("api/returnbyelyor/returns/full", body);
      message.success(t("saved"));
      setEditing(false);
      onSaved?.();
    } catch (err) {
      console.error(err);
      message.error(t("error"));
    } finally {
      setSaving(false);
    }
  };

  // const handleSaveCarNum = async () => {
  //   setSavingCarNumber(true);
  //   try {
  //     await http.patch(
  //       `api/returnbyelyor/returns/car-number/${data.docEntry}?carNumber=${carNumber}`,
  //       {},
  //     );
  //     message.success(t("saved"));
  //     setEditing(false);
  //     onSaved?.();
  //   } catch (err) {
  //     console.error(err);
  //     message.error(t("error"));
  //   } finally {
  //     setSavingCarNumber(false);
  //   }
  // };

  // const handleSaveLoaders = async (res) => {
  //   setSavingLoaders(true);
  //   try {
  //     await http.patch(
  //       `api/returnbyelyor/returns/delivery-id/${data.docEntry}?deliveryId=${res?.docEntry}`,
  //       {},
  //     );
  //     message.success(t("saved"));
  //     setEditing(false);
  //     onSaved?.();
  //   } catch (err) {
  //     console.error(err);
  //     message.error(t("error"));
  //   } finally {
  //     setSavingLoaders(false);
  //   }
  // };

  const getLoadersShipping = async (docEntry) => {
    if (!docEntry) {
      setLoaders([]);
      setSelectedLoadersData([]);
      setSavingLoaders(false);
      return;
    }
    setLoadingLoaders(true);
    try {
      const { data } = await http.get(
        `api/deliverynotesdata/get-employees?docEntry=${docEntry}`,
      );
      const resData = data[0]?.documentLines || [];
      const loaders = resData?.map((item) => item?.employeeID) || []; //Bu Selecda getida kelganlar tanlanib qolishi uchun qilindi
      const selectedDataLoaders = resData.map((item, index) => ({
        cardCode: item.employeeID,
        cardName: item.employeeName,
      })); // Bu Backendga jonatvotgan selectda shunaqa tartibda olinganakan shunichun yozildi bu
      setLoaders(loaders);
      setSelectedLoadersData(selectedDataLoaders);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingLoaders(false);
    }
  };

  // const postLoadersShipping = async () => {
  //   setSavingLoaders(true);
  //   console.log("loaders", loaders, selectedLoadersData);

  //   const orderDeliveryCollection = selectedLoadersData.map((item, index) => ({
  //     lineId: index + 1,
  //     employeeId: item.cardCode,
  //     employeeName: item.cardName,
  //   }));

  //   const postingData = {
  //     createdDate: moment().format("YYYY-MM-DD"),
  //     orderDeliveryCollection,
  //   };

  //   try {
  //     await http.post(
  //       `/api/returnbyelyor/create-delivery/${data?.docEntry}`,
  //       postingData,
  //     );

  //     message.success(t("sucChanged"));
  //     onSaved?.();
  //     setSavingLoaders(false);
  //   } catch (error) {
  //     message.error(error.response.data.message || error.message);
  //     setSavingLoaders(false);
  //   } finally {
  //     setSavingLoaders(false);
  //   }
  // };

  // const patchLoadersShipping = async () => {
  //   setSavingLoaders(true);
  //   const employeeLines = selectedLoadersData.map((item, index) => ({
  //     lineId: index + 1,
  //     employeeId: item.cardCode,
  //     employeeName: item.cardName,
  //   }));

  //   const postingData = {
  //     docEntry: data?.deliveryId,
  //     employeeLines,
  //   };

  //   try {
  //     await http.patch(
  //       `/api/inventorytransferrequest/employee/delivery/${data?.deliveryId}`,
  //       postingData,
  //     );
  //     message.success(t("sucEdit"));
  //     onSaved?.();
  //   } catch (error) {
  //     message.error(error.response.data.message || error.message);
  //   } finally {
  //     setSavingLoaders(false);
  //   }
  // };

  // const handleShippingLoadersBtnClick = async () => {
  //   if (data?.deliveryId) {
  //     patchLoadersShipping();
  //   } else {
  //     postLoadersShipping();
  //   }
  // };

  // const handleSaveDriver = async () => {
  //   setSavingDriver(true);
  //   try {
  //     await http.patch(
  //       `api/returnbyelyor/returns/driver/${data.docEntry}?driver=${driver}`,
  //       {},
  //     );
  //     message.success(t("saved"));
  //     setEditing(false);
  //     onSaved?.();
  //   } catch (err) {
  //     console.error(err);
  //     message.error(t("error"));
  //   } finally {
  //     setSavingDriver(false);
  //   }
  // };

  const lineColumns = [
    {
      title: t("lineNum"),
      dataIndex: "lineNum",
      key: "lineNum",
      width: 70,
    },
    {
      title: t("itemType"),
      dataIndex: "itemType",
      key: "itemType",
      width: 80,
    },
    {
      title: t("itemCode"),
      dataIndex: "itemCode",
      key: "itemCode",
      width: 120,
    },
    {
      title: t("item"),
      dataIndex: "itemDescription",
      key: "itemDescription",
      width: 200,
    },
    {
      title: t("quantity"),
      dataIndex: "quantity",
      key: "quantity",
      width: 120,
      render: (_, record) =>
        editing ? (
          <Input
            type="number"
            value={record._editQty}
            min={0}
            onChange={(e) => handleQtyChange(record.lineNum, e.target.value)}
            style={{ width: 90 }}
          />
        ) : (
          fmt(record.quantity)
        ),
    },
    {
      title: t("openQty"),
      dataIndex: "openQty",
      key: "openQty",
      width: 90,
      render: (v) => fmt(v),
    },
    {
      title: t("measureUnit"),
      dataIndex: "uoMCode",
      key: "uoMCode",
      width: 80,
    },
    {
      title: t("discountPercent"),
      dataIndex: "discountPercent",
      key: "discountPercent",
      width: 90,
      render: (v) => `${v ?? 0}%`,
    },
    {
      title: t("price"),
      dataIndex: "price",
      key: "price",
      width: 110,
      render: (v, r) => `${fmt(v)} ${r.currency}`,
    },
    {
      title: t("totalMiqdor"),
      dataIndex: "lineTotal",
      key: "lineTotal",
      width: 120,
      render: (v, r) => {
        const val = r.currency === "UZS" ? r.rowTotalFC ?? v : v;
        return `${fmt(val)} ${r.currency}`;
      },
    },
    {
      title: t("whs"),
      dataIndex: "warehouseCode",
      key: "warehouseCode",
      width: 90,
    },
  ];

  const docTotal =
    data.docCurrency === "UZS"
      ? `${fmt(data.docTotalFc)} UZS`
      : `${fmt(data.docTotal)} ${data.docCurrency}`;

  // const isBtnDisabled = false;
  const isBtnDisabled =
    !data.documentStatus || data.documentStatus === "C" || isShowDrivers;

  return (
    <Modal
      title={
        <h1 className="font-nunito text-xl font-extrabold text-[#000000]">
          ORDN (Return) № {data.docNum}
        </h1>
      }
      open={visible}
      visible={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      width="90%"
      bodyStyle={{ overflowY: "auto", maxHeight: "80vh" }}
    >
      <div className="px-4 pb-6">
        {/* Header fields */}
        <div className="flex justify-between">
          <div className="grid grid-cols-3 gap-5">
            <Field
              label={t("status")}
              value={
                data.documentStatus === "O"
                  ? t("open")
                  : data.documentStatus === "C"
                    ? t("closed")
                    : data.documentStatus
              }
            />

            <Field label={t("cardCode")} value={data.cardCode} />
            <Field label={t("cardName")} value={data.cardName} />
            <Field label={t("slpName")} value={data.salesPersonName} />

            <Field
              label={t("returnReason")}
              value={data.returnReasonName ?? data.returnReason ?? "-"}
            />
          </div>
          <div className="">
            <Field
              label={t("docDate")}
              value={
                data.docDate ? moment(data.docDate).format("DD.MM.YYYY") : "-"
              }
            />
          </div>
        </div>

        {/* Edit / Save button */}
        {isEditable && data?.documentStatus === "O" && (
          <div className="mt-6 flex items-center justify-end gap-4">
            {editing && (
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-500">
                  {t("To'liq Qaytarish")}
                </span>
                <Switch checked={closeDoc} onChange={setCloseDoc} />
              </div>
            )}
            {editing ? (
              <Button
                icon={<SaveOutlined />}
                loading={saving}
                disabled={
                  lines?.some((l) => !l._editQty || l._editQty == 0) ||
                  !loaders.length
                }
                onClick={handleSave}
                className="bg-[#0A4D68] text-white"
              >
                {t("save")}
              </Button>
            ) : (
              <Button
                icon={<EditOutlined />}
                onClick={() => setEditing(true)}
                className="bg-[#0A4D68] text-white"
              >
                {t("transferReturn")}
              </Button>
            )}
          </div>
        )}

        {/* Document lines table */}
        <Table
          className="mt-4"
          columns={lineColumns}
          dataSource={lines}
          rowKey={(r) => r.lineNum}
          pagination={false}
          scroll={{ x: 1100 }}
          size="small"
        />
      </div>

      <div className="flex justify-between gap-5">
        <div className="grid grid-cols-1 gap-5">
          <div className="col-span-2">
            <p className="text-xs text-gray-500">{t("comments")}</p>

            <Input.TextArea
              label={t("comments")}
              value={data.comments}
              disabled
              rows={3}
              className="mt-2 min-w-[300px]"
            />
          </div>
        </div>
        <div className="grid grid-cols-2 justify-end gap-5">
          <Field label={t("weight")} value={fmt(data.weight)} />
          <Field label={t("volume")} value={fmt(data.volume)} />

          <Field label={t("docTotal")} value={docTotal} />
          {/* <Field
            label={t("docTotalFc")}
            value={`${fmt(data.docTotalFc)} ${data.docCurrency}`}
          /> */}
        </div>
      </div>

      {(isShowDrivers || editing) && (
        <>
          <div className="mt-6 flex justify-between gap-6">
            <div className="flex flex-col gap-2">
              <div className="flex min-w-[350px] flex-col flex-wrap gap-2">
                <p className="text-xs text-gray-500">{t("loaders")}</p>
                <Select
                  mode="multiple"
                  value={loaders}
                  options={loadersData.map((item) => ({
                    label: item.cardName,
                    value: item.cardCode,
                    data: item,
                  }))}
                  placeholder={t("loaders")}
                  disabled={isBtnDisabled}
                  onChange={(val, option) => {
                    setLoaders(val);
                    console.log(
                      "option",
                      option?.map((item) => item.data),
                    );
                    setSelectedLoadersData(option?.map((item) => item.data));
                  }}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className="w-full"
                />
              </div>
              {/* <div className="mt-2 flex justify-end">
                <Button
                  icon={<SaveOutlined />}
                  loading={savingLoaders}
                  disabled={
                    isBtnDisabled ||
                    savingLoaders ||
                    savingDriver ||
                    saving ||
                    savingCarNumber ||
                    !loaders ||
                    loaders.length === 0
                  }
                  onClick={handleShippingLoadersBtnClick}
                  className="bg-[#0A4D68] text-white"
                >
                  {t("saveLoaders")}
                </Button>
              </div> */}
            </div>

            <div className="flex min-w-[350px] flex-col flex-wrap gap-2">
              <div className="flex w-full flex-col gap-2 sm:w-[350px]">
                <p className="text-xs text-gray-500">{t("driver")}</p>
                <Select
                  value={driver}
                  placeholder={t("chooseDriver")}
                  onChange={(val) => setDriver(val)}
                  options={driversData.map((item) => ({
                    label: item.cardName,
                    value: item.cardCode,
                  }))}
                  showSearch
                  disabled={isBtnDisabled}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className="w-full"
                />
              </div>
              {/* <div className="mt-2 flex justify-end">
                <Button
                  icon={<SaveOutlined />}
                  loading={savingDriver}
                  onClick={handleSaveDriver}
                  disabled={
                    !driver ||
                    savingDriver ||
                    savingCarNumber ||
                    isBtnDisabled ||
                    savingLoaders
                  }
                  className="bg-[#0A4D68] text-white"
                >
                  {t("saveDriver")}
                </Button>
              </div> */}
              <div className="flex w-full flex-col gap-2 sm:w-[350px]">
                <p className="text-xs text-gray-500">{t("carNumber")}</p>
                <Select
                  value={carNumber}
                  onChange={(val) => setCarNumber(val)}
                  options={carNumbersData.map((item) => ({
                    label: item.descr,
                    value: item.fldValue,
                  }))}
                  showSearch
                  disabled={isBtnDisabled}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className="w-full"
                />
              </div>
              {/* <div className="mt-2 flex justify-end">
                <Button
                  icon={<SaveOutlined />}
                  loading={savingCarNumber}
                  onClick={handleSaveCarNum}
                  disabled={
                    !carNumber ||
                    isBtnDisabled ||
                    savingCarNumber ||
                    savingDriver ||
                    savingLoaders
                  }
                  className="bg-[#0A4D68] text-white"
                >
                  {t("saveCarNumber")}
                </Button>
              </div> */}
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};

const Field = ({ label, value, className }) => (
  <div className={`flex flex-col gap-1 ${className}`}>
    <p className="text-xs text-gray-500">{label}</p>
    <Input
      value={value ?? "-"}
      disabled
      style={{ color: "black" }}
      className="h-8 font-medium"
    />
  </div>
);

export default ReturnRequestModal;
